import styles from "./Tab.module.scss";

import React, { memo, useEffect } from "react";
import classNames from "classnames";

import { ChatAction, ChatMenu, useAccount, useChatInfo, useSchedule, useSetChatInfo } from "@shared/contexts";
import { usePartnerStore } from "../../stores/partnerStore";


interface Props {
  isUser: boolean
}

export default memo(function Tab({isUser = true}: Props) {
  const {chatMenu, hasNewMessage} = useChatInfo()
  const setChatInfo = useSetChatInfo()
  const {schedule} = useSchedule()
  const {partnerStockList,} = usePartnerStore()

  const isPaidSchdule = schedule?.paymentInformation === "PAID"

  useEffect(() => {
    if (!schedule) return

    let chatMenu: ChatMenu
    if (isUser) {
      if (schedule.isChatEnabled) {
        chatMenu = "USER"
      } else {
        if (isPaidSchdule) {
          chatMenu = "MANAGER"
        } else {
          chatMenu = "USER"
        }
      }
    } else {
      chatMenu = "USER"
    }

    setChatInfo({
      type: "CHANGE_MENU_STATE",
      chatMenu: chatMenu
    })
  }, [schedule, isUser]);

  useEffect(() => {
    if (!isUser) return;

    const chatMenu = isPaidSchdule ? "MANAGER" : "USER"
    setChatInfo({
      type: "CHANGE_MENU_STATE",
      chatMenu: chatMenu
    })

  }, [isUser]);

  if (schedule?.paymentInformation === undefined || schedule?.paymentInformation === null) {
    return null
  }

  return (
    <div className={classNames("tabB", styles.chattingTab)}>
      {/* 일반 사용자일 때. */}
      {isUser ? (
        schedule.isChatEnabled ? (
          !isPaidSchdule ? (
            <>
              {getUserMessage(isUser, chatMenu, setChatInfo)}
              {getPartnerMessage(isUser, chatMenu, setChatInfo, hasNewMessage)}
            </>
          ) : (
            <>
              {getUserMessage(isUser, chatMenu, setChatInfo)}
              {getTradeList(chatMenu, setChatInfo, partnerStockList.isView)}
            </>
          )
        ) : (
          isPaidSchdule ? (
            <>
              {getPartnerMessage(isUser, chatMenu, setChatInfo, hasNewMessage)}
              {getTradeList(chatMenu, setChatInfo, partnerStockList.isView)}
            </>
          ) : (
            <>
              {getUserMessage(isUser, chatMenu, setChatInfo)}
              {getPartnerMessage(isUser, chatMenu, setChatInfo, hasNewMessage)}
            </>
          )
        )
      ) : (
        // 스트리머, 매니저일 때.
        <>
          {getUserMessage(isUser, chatMenu, setChatInfo)}
          {getPartnerMessage(isUser, chatMenu, setChatInfo, hasNewMessage)}
        </>
      )}
    </div>
  )
})


function getUserMessage(
  isUser: boolean,
  chatMenu: ChatMenu,
  setChatInfo: (value: ChatAction) => void,
) {
  return (
    <a
      className={classNames({
        on: (isUser ? chatMenu === "USER" : chatMenu === "USER" || chatMenu === "MANAGER"),
      })}
      onClick={(e) => {
        e.preventDefault()

        setChatInfo({
          type: "CHANGE_MENU_STATE",
          chatMenu: "USER",
        })
      }}
      title="전체메시지"
    >
      전체메시지
      {!isUser && (
        <button
          type="button"
          className={classNames(styles.messageFilter, {
            [styles.active]: chatMenu === "USER",
          })}
          title={chatMenu === "USER" ? "전문가채팅" : "전체채팅"}
          onClick={(e) => {
            e.stopPropagation()

            setChatInfo({
              type: "CHANGE_CHAT_GROUP",
              chatMenu: chatMenu === "USER" ? "MANAGER" : "USER",
            })
          }}
        >
          채팅 필터
        </button>
      )}
    </a>
  )
}

function getPartnerMessage(
  isUser: boolean,
  chatMenu: ChatMenu,
  setChatInfo: (value: ChatAction) => void,
  hasNewMessage: boolean,
) {
  return (
    <>
      <a
        className={classNames({
          on: isUser ? chatMenu === "MANAGER" : chatMenu === "PARTNER",
        })}
        onClick={(e) => {
          e.preventDefault()

          setChatInfo({
            type: "CHANGE_MENU_STATE",
            chatMenu: isUser ? "MANAGER" : "PARTNER",
          })
        }}
        title="파트너메시지"
      >
        파트너메시지
      </a>
      {hasNewMessage && (
        <div
          className={classNames(styles.newMessageNotice, {
            [styles.all]: chatMenu === "PARTNER",
          })}
        >
          N
        </div>
      )}
    </>
  )
}

function getTradeList(
  chatMenu: ChatMenu,
  setChatInfo: (value: ChatAction) => void,
  isView: "Y" | "N",
) {
  if (isView === "N") {
    return;
  }

  return <a
    className={classNames({
      on: (chatMenu === "TRADER"),
    })}
    onClick={(e) => {
      e.preventDefault()
      setChatInfo({
        type: "CHANGE_MENU_STATE",
        chatMenu: "TRADER",
      })
    }}
    title="매매전략"
  >
    매매전략
  </a>
}